export default __webpack_public_path__ + "static/media/shyft-workforce-logo-black-text.aee3b64b.svg";